import { html } from 'lit-html';

export const TableTooltipPriceSort = () => {
  return html`
    <div class="o-colBox -margin16 -fdcolumn">
      <a
        href="javascript:;"
        onclick="TRYLION.Env.FUNCTIONS.variationSortPriceDesc(this)"
        class="a-textlink -black"
      >
        価格の高い順で並び替え
      </a>
      <a
        href="javascript:;"
        onclick="TRYLION.Env.FUNCTIONS.variationSortPriceAsc(this)"
        class="a-textlink -black"
      >
        価格の安い順で並び替え
      </a>
    </div>
  `;
};
